import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'micro-region-select',
  templateUrl: './region-select.component.html'
})
export class RegionSelectComponent implements OnInit, OnChanges {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  allLabel:string = 'All';

  @Input()
  allSelectOption:boolean = false;

  @Input()
  requiredLabel:string;


  @Input()
  mode:string = 'simple';

  @Output()
  regionIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  regionId:any;

  @Input()
  contactId:any;

  @Input()
  forMe:boolean = false;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  sizeDynamically:boolean = false;

  @Input()
  jump:boolean = true;

  @Input()
  companyId:any;

  options:any[];

  initialCompanyId:any;
  initialRegionId:any;

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  change(e) {
    this.regionIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'forMe' || prop === 'companyId') {
        this.reloadDebounce();
      }
    }
  }

  reload() {
    let params:HttpParams = new HttpParams()
        .set("forMe", ''  + this.forMe)
    ;

    if (this.contactId) {
      params = params.set("contactId", this.contactId);
    }

    if (this.companyId) {
      params = params.set("cId", this.companyId);
    }

    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/domain/regions/all`, {params:params})
      .subscribe(data => {
        var dataOptions = data as any[];

        if (dataOptions.length && this.allSelectOption) {
          dataOptions.unshift({id:"--ALL--", name:this.allLabel})
        }

        this.options = dataOptions as any[];

        if (this.companyId === this.initialCompanyId) {
          if (this.regionId !== this.initialRegionId) {
            this.regionId = this.initialRegionId;
            this.change(this.initialRegionId);
          }
        } else {
          this.regionId = undefined;
          this.change(undefined);
        }

        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.initialCompanyId = this.companyId;
    this.initialRegionId = this.regionId;
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounce();
  }

  reloadDebounce() {
    this.reloadDebouncer.emit();
  }
}
